import axios from 'axios';
import { redirect } from '../utils/redirect';
import { clearCache } from '../utils/storage';
import { URL_NEW_SESSION, URL_SESSION } from '../constants/urls';
import { FLAG_CACHE_KEY } from '../constants';

export const FETCH_SESSION_NEW_REDIRECT = 'FETCH_SESSION_NEW_REDIRECT';
export const FETCH_SESSION_NEW_FAILURE = 'FETCH_SESSION_NEW_FAILURE';

export const FETCH_SESSION_END_BEGIN = 'FETCH_SESSION_END_BEGIN';
export const FETCH_SESSION_END_FAILURE = 'FETCH_SESSION_END_FAILURE';

export const FETCH_SESSION_BEGIN = 'FETCH_SESSION_BEGIN';
export const FETCH_SESSION_SUCCESS = 'FETCH_SESSION_SUCCESS';
export const FETCH_SESSION_FAILURE = 'FETCH_SESSION_FAILURE';
export const FETCH_SESSION_ERROR = 'FETCH_SESSION_ERROR';

const FORWARDED_OPS = ['reset'];

export const sessionNew = () => async (dispatch) => {
  dispatch({ type: FETCH_SESSION_NEW_REDIRECT });

  try {
    // The landing page's op (e.g. reset) picks where the IdP sends a signed-out member.
    const requestedOp = new URLSearchParams(window.location.search).get('op');
    const op = FORWARDED_OPS.includes(requestedOp) ? requestedOp : undefined;
    const response = await axios.get(URL_NEW_SESSION, { params: { op } });

    const { url } = response.data;

    if (url) {
      redirect(url, window.location.pathname + window.location.search);
    } else {
      throw new Error('GET /session/new did not respond with a url');
    }
  } catch (error) {
    dispatch({ payload: error.message, type: FETCH_SESSION_NEW_FAILURE });
  }
};

export const sessionCheck = () => async (dispatch) => {
  dispatch({ type: FETCH_SESSION_BEGIN });

  try {
    const response = await axios.get(URL_SESSION);

    const { data } = response;
    dispatch({
      payload: data,
      type: FETCH_SESSION_SUCCESS,
    });
  } catch (error) {
    dispatch(sessionNew());
  }
};

export const sessionEnd = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_SESSION_END_BEGIN, userId });

  // The flag cache isn't per-user.
  clearCache(FLAG_CACHE_KEY);

  try {
    const response = await axios.delete(URL_SESSION);
    const { url } = response.data;

    window.location.assign(url);
  } catch (error) {
    dispatch({ payload: error.message, type: FETCH_SESSION_END_FAILURE });
  }
};
